import React from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";
import {
  GetClientLargeClaimUWPEPMByClientName,
  UpdateLargeClaimUWPemp,
  UpdateLargeClaimUWPempbyClient,
} from "../../../../api/User/ACG/LargeClaimeUWApi";
import { useSelector } from "react-redux";
import { render } from "@testing-library/react";

const schema = Yup.object().shape({
  acg_Output_PEPM: Yup.number()
    .typeError("Please enter a valid number")
    .required("required"),
  pepm: Yup.number()
    .typeError("Please enter a valid number")
    .required("required"),
});

const LargeClaimUW = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isGetData, setIsGetData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [importConformationModal, setImportConformationModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Client ID", field: "client_ID" },
    { title: "Carrier", field: "carrier" },
    { title: "Large Claim Output PEPM", field: "acg_Output_PEPM", render: (data) => +data.acg_Output_PEPM.toFixed(3) },
    {
      title: "Large Claim Output IRMI/AEGIS PEPM",
      field: "pepm",
      render: (data) => data.pepm.toFixed(3),
    },
    {
      title: "Outlier - Override",
      field: "outlier_Large_Claim",
      render: (data) => data.outlier_Large_Claim ? 'Yes' : "",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getData();
  }, [client]);

  const getData = () => {
    setIsLoading(true);
    GetClientLargeClaimUWPEPMByClientName(client?.clientID)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    const { acg_Output_PEPM, pepm } = values;
    const payload = {
      id: selectedRowData?.id,
      client_ID: client?.clientID,
      carrier: selectedRowData?.carrier,
      acg_Output_PEPM: +acg_Output_PEPM,
      pepm: +pepm,
    };

    UpdateLargeClaimUWPemp(payload).then((res) => {
      if (res.status === 200 || res.status === 204) {
        if(res.data === "failed"){
          toastFile("failed")
        }else{
          toastFile("update");
        }
        setIsGetData(true);    
        setShowModal(false);
      }
    });
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Update Large Claim PEPM
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={handleActions}
            initialValues={{
              acg_Output_PEPM: selectedRowData?.acg_Output_PEPM.toFixed(3) ?? 0,
              pepm: selectedRowData?.pepm.toFixed(3) ?? 0,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mb-2 gap-3">
                  <CustomInputField
                    label="Large Claim Output PEPM"
                    name="acg_Output_PEPM"
                    maxLength={10}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    isRequired
                  />
                  <CustomInputField
                    label="Large Claim Output IRMI/AEGIS PEPM"
                    name="pepm"
                    maxLength={10}
                    value={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                    errors={errors}
                    isRequired
                  />
                </Row>
                <div className="text-end my-4">
                  <CustomButton
                    Ref={buttonRef}
                    style={Fontstyling.savebutton}
                    type="submit"
                  >
                    Save
                  </CustomButton>
                  <CustomButton
                    style={Fontstyling.cancelbutton}
                    onClick={() => setShowModal(false)}
                    type="button"
                  >
                    Cancel
                  </CustomButton>
                </div>
                <span className="text-success" style={{ fontSize: "12px" }}>
                  * No special characters are allowed
                </span>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <Modal
        show={importConformationModal}
        onHide={() => setImportConformationModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        You have selected to override the system calculated PEPM value with IRMI Large Claim Benchmark. Do you want to proceed?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              setImportConformationModal(false);
              UpdateLargeClaimUWPempbyClient(
                client?.clientID,
                user.UD_id
              ).then((res) => {
                if (res.status === 200 || res.status === 204) {
                  toastFile("update");
                  getData();
                }
              });
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setImportConformationModal(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      {data.length > 0 && <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            if (
              client === null ||
              client?.clientID === null ||
              client?.clientID === 0
            ) {
              toastFile("Select Client");
            } else {
              setImportConformationModal(true);
            }
          }}
        >
          Override with IRMI Benchmark
        </CustomButton>
      </div>}
      <CustomMaterialTable
        isExport={false}
        isDelete={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={() => {}}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LargeClaimUW;
